import { Card, CardContent, CardHeader, Divider } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "underscore";
import { fetchUserReferralRequest } from "../../store/user/user.actions";
import { getUserReferrals } from "../../store/user/user.selector";
import TitleBar from "../base/TitleBar";

export default function RefereeContainer() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserReferralRequest());
  }, []);

  const { referals } = useSelector((state) => {
    return {
      referals: getUserReferrals(state),
    };
  }, []);

  let data = _.sortBy(referals.children, "depth");
  data = _.groupBy(data, "depth");

  return (
    <div>
      <TitleBar heading="Referrals" secondary={""} icon={<HelpOutlineIcon />} />
      <div className="content-height m-2 p-2">
        {Object.keys(data).map((x) => {
          const columns = ["Member #", "Name", "Mobile Number", "Activated On"];

          const datum = data[x].map((y) => {
            return [
              y.memberId,
              y.firstName + " " + y.lastName,
              y.mobileNumber.replace(/\D/g, "").substr(0, 5) + "XXXXX",
              y.activatedOn
                ? moment(y.activatedOn).format("DD/MM/YYYY hh:mm:ss A")
                : "Not Activated",
            ];
          });

          const options = {
            selectableRows: false,
            download: false,
            print: false,
            rowsPerPage: 100,
          };
          return (
            <Card elevation={10} className="mb-2">
              <CardHeader
                title={"Level " + (parseInt(x) + 1)}
                subheader="Member Information"
              />
              <Divider />
              <CardContent>
                <MUIDataTable
                  title={"Member List"}
                  data={datum}
                  columns={columns}
                  options={options}
                />
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
